import { CsbHelper, getTemplateValues } from '@recruiting-solutions/rs-shared';

export async function getCountryCodes() {
    const locale = CsbHelper.getLocale();
    return locale ? COUNTRY_ORDER[locale.split('_')[1]] : COUNTRY_ORDER['US'];
}

const COUNTRY_ORDER: { [key: string]: string } = {
    US: 'US,MX,GB,FR,NL',
    DE: 'US,MX,GB,FR,NL',
};

export var UtmParams = ['utm_campaign', 'utm_source', 'utm_medium'];

export var SFUtmParams = ['custSourceData03', 'custSourceData01', 'custSourceData02'];

export function getCountry() {
    const pathName = window.location.pathname;
    const parts = pathName.split('/');
    let country = '';
    if (parts.length > 2) {
        if (parts[1].length === 2) {
            // part[0] is the country if it has a length of 2 e.g. /de/
            country = parts[1].toUpperCase();
        }
    }
    return country;
}

export function getShareIconsByLocale(): { label: string; icon: string }[] {
    const locale = CsbHelper.getLocale();
    const i18n = getTemplateValues('jobPosting');

    switch (locale) {
        case 'de_DE':
            return [
                { label: i18n('shareIconTitle0'), icon: 'linkedin' },
                { label: i18n('shareIconTitle1'), icon: 'xing' },
                { label: i18n('shareIconTitle2'), icon: 'clipboard' },
            ];
        default:
            return [
                { label: i18n('shareIconTitle0'), icon: 'linkedin' },
                { label: i18n('shareIconTitle2'), icon: 'clipboard' },
            ];
    }
}

export function stripHTML(html){
    let doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
 }